import moment from 'moment';

export const LINK_HOLD_STATE = Object.freeze({
    ENGINE_HOLDS: 'ENGINE_HOLDS',
    ENGINE_WILL_PICK: 'ENGINE_WILL_PICK',
    ENGINE_INTAKE_GRACE: 'ENGINE_INTAKE_GRACE',
    OUT_OF_ENGINE_REACH: 'OUT_OF_ENGINE_REACH',
    RELEASED_BY_CEILING: 'RELEASED_BY_CEILING',
});

const MARK_LABEL_BY_STATE = Object.freeze({
    [LINK_HOLD_STATE.ENGINE_HOLDS]: (releaseAt) => `Agendado ${moment(releaseAt).format('DD/MM HH:mm')}`,
    [LINK_HOLD_STATE.ENGINE_WILL_PICK]: () => 'Aguardando o motor',
});

export const isHeldByPromotionGate = (linkHold) => !!(linkHold && linkHold.blocked);

export const shouldShowLinkHoldMark = (linkHold, isInternal) =>
    !!(isInternal && isHeldByPromotionGate(linkHold) && MARK_LABEL_BY_STATE[linkHold.state]);

export const linkHoldMarkLabel = (linkHold) => {

    const buildLabel = MARK_LABEL_BY_STATE[(linkHold || {}).state];

    return buildLabel ? buildLabel(linkHold.releaseAt) : null;
};

export const linkHoldScheduledAtLabel = (linkHold) =>
    (linkHold && linkHold.state === LINK_HOLD_STATE.ENGINE_HOLDS && linkHold.releaseAt)
        ? moment(linkHold.releaseAt).format('DD/MM [às] HH:mm')
        : null;

export const linkHoldTooltip = (linkHold) => {

    if (!linkHold)
        return '';

    if (linkHold.state === LINK_HOLD_STATE.ENGINE_WILL_PICK)
        return 'A Soberania ainda vai processar esta solicitação. Vincular na mão agora exige motivo declarado.';

    const slackLabel = linkHold.slackHours
        ? ` Folga de ${Math.round(linkHold.slackHours)}h contra limiar de ${Math.round(linkHold.thresholdHours)}h.`
        : '';

    return `Fora da Central de Vinculações até o despacho agendado.${slackLabel} Vincular na mão antes disso exige motivo declarado.`;
};

export const linkHoldHeldUntilLabel = (linkHold) =>
    (linkHold && linkHold.releaseAt)
        ? ` até ${moment(linkHold.releaseAt).format('DD/MM [às] HH:mm')}`
        : '';
